import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Box,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";

import Loader from "../Loader";
import { esignIcons } from "../Esign/icons";
import { getStatusStyles } from "../../heplers";
import { esignToolApi } from "../../services/esignApi";

const BulkEsignTable = (props) => {
  const { documents, totalPages, loader, setLoader, fetchAllDocuments, currentPage, setCurrentPage } = props;
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [openDetails, setOpenDetails] = useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [signersStatus, setSignersStatus] = useState([]);

  const handleChangePage = (_, newPage) => {
    if (newPage + 1 <= totalPages) {
      setCurrentPage(newPage + 1);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  const handleMenuOpen = (event, doc) => {
    setMenuAnchorEl(event.currentTarget);
    setSelectedDoc(doc);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedDoc(null);
  };

  const handleExpire = () => {
    console.log("Expire document:", selectedDoc?.document_id);
    handleMenuClose();
  };

  const handlePreview = (docUrl) => {
    console.log("Preview document:", selectedDoc?.document_id);
    handleMenuClose();
  };

  const handleDownload = (docUrl) => {
    // const link = document.createElement("a");
    // link.href = docUrl;
    // link.download = docUrl.split("/").pop();
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
    console.log("Download document:", selectedDoc?.document_id);
    handleMenuClose();
  };

  const handleDocumentDetails = async (row) =>
  {
    setLoader(true)
    setOpenDetails(true)
    try {
      const response = await esignToolApi.getAllSignerStatus(row?.document_id);
      setLoader(false)
      console.log(response)
      if (response) {
        setSelectedDoc(row)
        setSignersStatus(response?.data)
      }
    } catch (error) {
      setLoader(false)
      console.error("Error fetching data:", error);
    }
  }

  return (
    <>
        <Paper sx={{ width: "100%", overflow: "auto", boxShadow: "none", height: "90%", }}>
        <TableContainer>
            <Table>
            <TableHead sx={{ background: "#F5F5F5", fontSize: "15px", fontWeight: 500, color: "#1D1D1D" }}>
                <TableRow>
                <TableCell sx={{  pl: "30px", }}>S. No.</TableCell>
                <TableCell>Document Name</TableCell>
                <TableCell>No. of Signers</TableCell>
                <TableCell>Pending Signers</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Action</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {documents.length > 0 ? (
                documents.map((row, index) => (
                    <TableRow key={row.document_id} onClick={() => handleDocumentDetails(row)} sx={{
                        "&:hover": { backgroundColor: "#f5f5f5",}
                    }}>
                        <TableCell sx={{ pl: "30px", cursor: "pointer" }}>{((currentPage - 1) * rowsPerPage + index + 1).toString().padStart(2, "0")}</TableCell>
                        <TableCell sx={{ cursor: "pointer" }}>{row.document_name}</TableCell>
                        <TableCell sx={{ cursor: "pointer",}}>
                        <Box sx={{ display: "flex", alignItems: "center", gap:1 }}>
                            {esignIcons.signersIcon}{`${(row.numberOfSigners).toString()}`}
                        </Box>
                        </TableCell>
                        <TableCell sx={{ cursor: "pointer",}}>
                        <Box sx={{ display: "flex", alignItems: "center", gap:1 }}>
                            {esignIcons.signersIcon}{`${(row.pendingSigners).toString()}`}
                        </Box>
                        </TableCell>
                        <TableCell sx={{ color: getStatusStyles(row.status).color, cursor: "pointer", textTransform: "capitalize" }}>{row.status}</TableCell>
                        <TableCell onClick={(e) => e.stopPropagation()} >
                        <IconButton
                            onClick={() => handlePreview(row.document_url)}
                        >
                            {esignIcons.eyeIcon}
                        </IconButton>
                        <IconButton
                            onClick={() => handleDownload(row.document_url)}
                        >
                            {esignIcons.downloadIcon}
                        </IconButton>
                        <IconButton onClick={(e) => handleMenuOpen(e, row)}>
                        {esignIcons.moreIcon}
                        </IconButton>
                        </TableCell>
                    </TableRow>
                    ))
                ) : (
                <TableRow>
                    <TableCell colSpan={6} align="center">
                    No documents found
                    </TableCell>
                </TableRow>
                )}
            </TableBody>
            </Table>
        </TableContainer>
        <TablePagination
            rowsPerPageOptions={[10]}
            component="div"
            count={totalPages * rowsPerPage}
            rowsPerPage={rowsPerPage}
            page={currentPage - 1}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
        </Paper>

        <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
            sx: {
                height: "50px",
                width: "168px",
                borderRadius: "10px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-evenly",
                overflow: "hidden",
            },
        }}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "center", 
        }}
        transformOrigin={{
            vertical: "top",
            horizontal: "right",
        }}
        >
        <MenuItem onClick={handleExpire} sx={{ fontSize: "14px", fontWeight: "400", color: "#595959", gap: 1 }} disabled={selectedDoc?.status === "Completed"}>{esignIcons.expireIcon} Expire Request</MenuItem>
        </Menu>
        {loader && <Loader />}
    </>
  );
};

export default BulkEsignTable;
